import React from 'react';
import { useSelector } from "react-redux";
import CurrencyFormat from 'react-currency-format';

const DepositDiscount = ({ isFor }) => {

  const state = useSelector((state) => ({
    ...state.reducer,
    ...state.orderExtrasReducer,
    ...state.priceUpdateReducer,
  }));

  let valueToShow = 0;

  if (
    isFor !== undefined &&
    isFor === 'DealerDiscount' &&
    state.const_var.post_data.building !== undefined &&
    state.const_var.post_data.building.down_payment_discount_total !== undefined
  ) {
    let newDownPaymentAmt = state.const_var.BuildingPriceArrar['new_down_payment_total'];

    if (state.const_var.order_extra_items['dont_show_processing_fee_pdf'] === '1') {
      newDownPaymentAmt = parseFloat(newDownPaymentAmt) - parseFloat(state.const_var.order_extra_items['processing_fee']);
    }

    valueToShow = (newDownPaymentAmt + state.const_var.BuildingPriceArrar['custom_down_payment_total'] + state.const_var.BuildingPriceArrar['grvy_value']).toFixed(2);
  }

  return (
    <>
      {isFor !== undefined && isFor === 'DealerDiscount' ? (
        <CurrencyFormat value={valueToShow} displayType={'text'} thousandSeparator={true} prefix={'$'} />
      ) : (
        <CurrencyFormat
          value={
            state.const_var.post_data.building !== undefined &&
            state.const_var.post_data.building.down_payment_discount_total !== undefined
              ? (
                  state.const_var.BuildingPriceArrar['new_down_payment_total'] +
                  state.const_var.BuildingPriceArrar['custom_down_payment_total'] +
                  state.const_var.BuildingPriceArrar['grvy_value']
                ).toFixed(2)
              : 0
          }
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
      )}
    </>
  );
};

export default DepositDiscount;